export const CONFIG_PROPERTY_EMAIL_KEYS = [
  "email.testing-mode-recipients",
  "email.testing-mode-fallback-recipients",
  "email.monly-error-recipients"
];
export const CONFIG_PROPERTY_PHONE_KEYS = ["sms.testing-mode-recipients", "sms.testing-mode-fallback-recipients"];
export const CONFIG_PROPERTY_FEATURE_KEYS = ["top-agent.allowed-features"];
